import { Truck, MessageCircle, ShieldCheck, Gift, Hourglass } from "lucide-react";

const ITEMS = [
  { icon: Truck, title: "Complimentary delivery", text: "On all orders above ₹999 across India" },
  { icon: MessageCircle, title: "Personal advisor", text: "Reach us on WhatsApp, 10am – 7pm IST" },
  { icon: ShieldCheck, title: "Secure payment", text: "UPI, cards & netbanking via Razorpay" },
  { icon: Gift, title: "Gift-ready packaging", text: "Signature black box with gold sleeve" },
  { icon: Hourglass, title: "Matured 8–10 weeks", text: "Every batch rests before bottling" },
];

export default function ServiceStrip() {
  return (
    <div data-testid="service-strip" className="border-b border-black/10">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-12 grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-6">
        {ITEMS.map(({ icon: Icon, title, text }) => (
          <div key={title} className="flex flex-col items-start md:items-center md:text-center gap-3">
            <Icon size={26} strokeWidth={1} className="text-[#BA8D53]" />
            <p className="text-[0.68rem] uppercase tracking-[0.2em] font-medium">{title}</p>
            <p className="text-xs text-black/50 leading-relaxed">{text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
